"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/useFileOpener.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _OpenFileFallbackModal = require('./OpenFileFallbackModal'); var _OpenFileFallbackModal2 = _interopRequireDefault(_OpenFileFallbackModal);
var _utils = require('./utils');


/* `download`, when given, saves the file from the fallback modal. */
const useFileOpener = (download) => {
  const [fallback, setFallback] = _react.useState(null)
  const closeFallback = _react.useCallback.call(void 0, () => setFallback(null), [])
  const openFile = _react.useCallback.call(void 0, 
    (requestUrl) => {
      setFallback(null)
      _utils.openFileInNewWindow.call(void 0, requestUrl, setFallback)
    },
    [],
  )

  return {
    openFile,
    fallbackNode: (
      _react2.default.createElement(_OpenFileFallbackModal2.default, {
        fallback: fallback,
        onClose: closeFallback,
        onDownload: download, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
      )
    ),
  }
}

exports. default = useFileOpener
